import { render } from "./aTab.vue?vue&type=template&id=ba81ebca&ts=true"
import script from "./aTab.vue?vue&type=script&lang=ts"
export * from "./aTab.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__